import React, { useRef } from 'react';
import { ExternalContentFragment } from '@/types';
import { ExternalContentView } from './external-content-view';
import { ExternalContentViewRef } from './external-content-view-types';
import { SessionService } from '@domain/auth/blocs/services/session-service';
import { StyleSheet, View } from 'react-native';
import { useUserContext } from '@/contexts/user-context';

const TRUSTED_ORIGINS = new Set(['https://d2ink7jjwtss74.cloudfront.net']);

interface Props {
  externalContent: ExternalContentFragment;
}

export const ExternalContentTool: React.FC<Props> = ({ externalContent }) => {
  const { selectedRestaurantRelationship, selectedRestaurantUUID } =
    useUserContext();

  const ref = useRef<ExternalContentViewRef>(null);

  return (
    <View style={styles.container}>
      <ExternalContentView
        externalContentName={
          externalContent.display_name || externalContent.name
        }
        externalContentURL={externalContent.config.url}
        onLoad={async () => {
          try {
            const toolOrigin = new URL(externalContent.config.url).origin;
            if (TRUSTED_ORIGINS.has(toolOrigin)) {
              ref.current?.postMessage(
                {
                  authToken: await SessionService.getIdToken(),
                  selectedBusinessUUID:
                    selectedRestaurantRelationship.supplierUUID,
                  selectedRestaurantUUID: selectedRestaurantUUID,
                  selectedSupplierUUID:
                    selectedRestaurantRelationship.supplierUUID,
                  type: 'AUTH_TOKEN',
                },
                toolOrigin,
              );
            }
          } catch {
            // Do nothing
          }
        }}
        ref={ref}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
